<template>
  <div id="app">
    <Header/>
    <router-view />
    <Footer/>
    <FeedbackPop :visible="feedbackVisible" @close="feedbackVisible = false" @enter="handleFeedbackEnter" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import FeedbackPop from "@/components/FeedbackPop.vue";
export default {
  components: {
    Header,
    Footer,
    FeedbackPop
  },
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      feedbackVisible: false
    };
  },
  computed:{
    lang() {
      return this.$i18n.locale;
    },
  },
  created() {
    this.$bus.$on('showFeedback', () => {
      this.feedbackVisible = true;
    });
  },
  beforeDestroy() {
    this.$bus.$off('showFeedback');
  },
  watch: {
    // 监听语言变化，动态更新页面标题
    '$i18n.locale'(newLang) {
      this.updatePageTitle();
      this.updateHtmlLang(newLang);
    }
  },
  mounted() {
    // 页面加载时设置初始标题
    this.updatePageTitle();
    // 页面加载时设置初始语言class
    this.updateHtmlLang(this.$i18n.locale);
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
    // 更新页面标题
    updatePageTitle() {
      document.title = this.$t('home.title');
    },
    // 更新HTML根元素的语言class
    updateHtmlLang(lang) {
      const html = document.documentElement;
      html.classList.remove('lang-zh', 'lang-en');
      html.classList.add(`lang-${lang}`);
    },
    handleFeedbackEnter() {
      this.feedbackVisible = false;
      // 这里可以添加进入问卷的逻辑，比如跳转链接
      if(this.lang === 'zh'){
        window.open('https://www.wenjuan.com/s/UZBZJvP9vtX/#', '_blank');
      }else {
        window.open('https://www.wenjuan.com/s/UZBZJvMuC5T/', '_blank');
      }
      
    }
  }
};
</script>

<style lang="scss">

</style>
